import classNames from 'classnames';
import {
  Icon,
  TitledBlock,
  ContentBlock,
  FlexContainer,
  Txt,
  View,
} from 'components';
import { fromSwiftDate } from 'helpers/swiftDateFormatter';
import { DateTime } from 'luxon';
import { observer } from 'mobx-react-lite';
import { usePublicAccount, useTenancy } from 'state';
import styles from './ViewPaymentsRentDetails.module.scss';

/**
 * ViewPaymentsRentDetails
 *
 * @return {JSX.Element}
 */
const ViewPaymentsRentDetails = ({ className }) => {
  const publicAccount = usePublicAccount();
  const tenancyDoc = useTenancy();
  const { data: tenancy } = tenancyDoc;

  return (
    <FlexContainer
      className={classNames(
        styles.ViewPaymentsRentDetails,
        className,
        ViewPaymentsRentDetails.displayName
      )}
      column
      gap
    >
      <ContentBlock gapHalf alignCenter>
        <FlexContainer column gapHalf flex>
          <Txt caption>RENT COLLECTION</Txt>
          <Txt xx>Begin soon</Txt>
          <Txt regular>
            Rent collection for this tenancy will begin on{' '}
            {DateTime.fromJSDate(
              fromSwiftDate(tenancy.dates.rentDueDates[0])
            ).toLocaleString(DateTime.DATE_FULL)}
            .
          </Txt>
        </FlexContainer>
        <Txt caption>
          <Icon name="calendar" />
        </Txt>
      </ContentBlock>
      {publicAccount.data.banking.plaidRecipientId ? (
        <TitledBlock title="Payments to">
          <ContentBlock column={false} row gap>
            <FlexContainer column gapHalf>
              <Txt></Txt>
              <Txt xx>{publicAccount.data.banking.accountName}</Txt>
              <Txt regular>
                Linked:{' '}
                {DateTime.fromJSDate(
                  fromSwiftDate(publicAccount.data.banking.dateUpdated)
                ).toLocaleString(DateTime.DATETIME_MED)}
              </Txt>
            </FlexContainer>
            <FlexContainer></FlexContainer>
          </ContentBlock>
        </TitledBlock>
      ) : null}
      <TitledBlock title="Payment dates">
        <ContentBlock column gapHalf noPadding>
          {tenancy.dates?.rentDueDates.map((d, idx) => (
            <View className={styles.DateItem} key={idx}>
              <Txt>
                {DateTime.fromJSDate(fromSwiftDate(d)).toLocaleString(
                  DateTime.DATE_FULL
                )}
              </Txt>
            </View>
          ))}
        </ContentBlock>
      </TitledBlock>
    </FlexContainer>
  );
};

ViewPaymentsRentDetails.displayName = 'ViewPaymentsRentDetails';

export default observer(ViewPaymentsRentDetails);
